module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_0@2x.d1265989.png";